/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleRectIcon16Solid = forwardRef('MoneyCurrencyRubleRectIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.2 5.2v1.6H9a.8.8 0 1 0 0-1.6H7.2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5v-6ZM7.2 8H9a2 2 0 1 0 0-4H6.781A.78.78 0 0 0 6 4.781v2.02h-.4a.6.6 0 1 0 0 1.2H6v.8h-.4a.6.6 0 1 0 0 1.2H6V11a.6.6 0 1 0 1.2 0v-1h2.2a.6.6 0 1 0 0-1.2H7.2V8Z" })));
});
